// SHOWS DISCLAIMERS
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
    disclaimerCard: {
      //padding: theme.spacing(2),
      textAlign: 'justify',
      color: theme.palette.text.secondary,
        //margin: theme.spacing(2),
        alignItems: 'center',
    },
      cardContent: {
          paddingTop: theme.spacing(0),
          paddintBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
  }));
  
export default function Disclaimer (props) {

    const classes = useStyles();

    const noticeImportant = "No single survey can give a definitive mental health diagnosis. The above apps are no substitute for a formal clinical evaluation. Please consult with your physician or mental health treater to discuss results.";

    const noticePrivacy = "This website does not encrypt data. Psych-Apps is intended for personal use. By using the above apps, you are endorsing understanding of the privacy disclaimer and that Psych-Apps is not liable for security of data."

    const createdBy = <><strong><em>FantesMD Psych-Apps</em></strong> was designed and developed by Francisco Fantes, MD for personal use. Last updated on April 9, 2024.</>;

    return <>
    <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box className={classes.disclaimerCard} key="notes">
                        <CardContent className={classes.cardContent} key="important note">
                            <br />
                            <Typography variant="subtitle2" color="inherit"><em>Important Note:</em> {noticeImportant}</Typography>
                        </CardContent>
                        <CardContent className={classes.cardContent} key="privacy note">
                            <Typography variant="subtitle2" color="inherit"><em>Privacy Disclaimer: </em> {noticePrivacy} Please review our <Link onClick={(e)=>e.preventDefault} href="/privacy-policy" target="_blank">Privacy Policy</Link> for more details.
                            </Typography>
                        </CardContent>
                        <CardContent className={classes.cardContent} key="creator note">
                            <Typography variant="subtitle2" color="inherit">{createdBy}</Typography>
                        </CardContent>
                    </Box>
                </Grid>
            </Grid>
    </>;
}